module.exports = __webpack_public_path__ + "b167d7f28bd707a74c8cdfd0222ffe76.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-8.png
// module id = 1448
// module chunks = 0